// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutActions-Icon_cls1__kQmyj","cls2":"PayoutActions-Icon_cls2__uWzAe PayoutActions-Icon_cls1__kQmyj"};